module.exports = __webpack_public_path__ + "static/media/card (3).4b92952d.pdf";